module.exports = __webpack_public_path__ + "3236800a.svg";